module.exports = __webpack_public_path__ + "static/media/HomeDashboard.a57d901b.svg";